export enum ActionType {
  LOGIN = "LOGIN",
  LOGOUT = "LOGOUT",
  UPSERT_CONVERSATION = "UPSERT_CONVERSATION",
  REMOVE_CONVERSATION = "REMOVE_CONVERSATION",
  UPDATE_CURRENT_CONVERSATION = "UPDATE_CURRENT_CONVERSATION",
  CONVERSATION_LAST_READ_INDEX = "CONVERSATION_LAST_READ_INDEX",
  ADD_MESSAGES = "ADD_MESSAGES",
  PUSH_MESSAGES = "PUSH_MESSAGES",
  REMOVE_MESSAGES = "REMOVE_MESSAGES",
  UPDATE_LOADING_STATE = "update loading state",
  UPDATE_PARTICIPANTS = "UPDATE_PARTICIPANTS",
  UPDATE_USER = "UPDATE_USER",
  UPDATE_UNREAD_MESSAGES = "UPDATE_UNREAD_MESSAGES",
  UPDATE_CONVERSATION = "UPDATE_CONVERSATION",
  ADD_ATTACHMENT = "ADD_ATTACHMENT",
  CLEAR_ATTACHMENTS = "CLEAR_ATTACHMENTS",
  TYPING_STARTED = "TYPING_STARTED",
  TYPING_ENDED = "TYPING_ENDED",
  ADD_NOTIFICATIONS = "ADD_NOTIFICATIONS",
  REMOVE_NOTIFICATIONS = "REMOVE_NOTIFICATIONS",
  FILTER_CONVERSATIONS = "FILTER_CONVERSATIONS",
  NEW_FILTER_CONVERSATIONS = "NEW_FILTER_CONVERSATIONS",
  UPDATE_TIME_FORMAT = "UPDATE_TIME_FORMAT",
  UPDATE_LOCAL = "UPDATE_LOCAL",
  SET_TWILIO_AUTH = "SET_TWILIO_AUTH",
  SET_CONVERSATIONS = "SET_CONVERSATIONS",
  SET_OPERATOR = "SET_OPERATOR",
  SET_ROLES = "SET_ROLES",
  SET_TEMPLATES = "SET_TEMPLATES",
  TEMPLATE_SEND_PENDING_SET = "TEMPLATE_SEND_PENDING_SET",
  // Contact
  SET_CUSTOMER_SEARCH_LOADING = "SET_CUSTOMER_SEARCH_LOADING",
  SET_CUSTOMER_SEARCH_RESULTS = "SET_CUSTOMER_SEARCH_RESULTS",
  // Action types
  SET_OPERATORS = "SET_OPERATORS",
  SET_OPERATORS_LOADING = "SET_OPERATORS_LOADING",
  RESET_OPERATORS = "RESET_OPERATORS",

  // Conversation action
  SET_CONVERSATION_ACTION = "SET_CONVERSATION_ACTION",

  // SignalR
  SIGNALR_CONNECTING = "SIGNALR_CONNECTING",
  SIGNALR_CONNECTED = "SIGNALR_CONNECTED",
  SIGNALR_DISCONNECTED = "SIGNALR_DISCONNECTED",
  SIGNALR_ERROR = "SIGNALR_ERROR",
  SIGNALR_EVENT_RECEIVED = "SIGNALR_EVENT_RECEIVED",

  // Contact conversation
  SET_CONTACT_CONVERSATION_LOADING = "SET_CONTACT_CONVERSATION_LOADING",
  SET_CONTACT_CONVERSATION = "SET_CONTACT_CONVERSATION",
  RESET_CONTACT_CONVERSATION = "RESET_CONTACT_CONVERSATION",
  SET_UNLOCK_REASONS = "SET_UNLOCK_REASONS",
}
